import { ROUTE_PATH_WIKI } from "page/wiki/wiki-config";

export const ROUTE_PATH_GAMEMODES = `${ROUTE_PATH_WIKI}/gamemodes`;
